export const PRIME_ACCOUNT = 'PREMIUM';
export const ACTIVE_ACCOUNTS = new Odigeo.Enum(['REGISTERED', PRIME_ACCOUNT]);

export const MEMBERSHIP_TYPE = {
    FREE_TRIAL: 'FreeTrial',
    SIX_MONTHS: '6Months',
    DEFAULT: '',
};

export const MEMBERSHIP_STATUS = {
    PENDING_COLLECT: 'PENDING_TO_COLLECT',
};

export const MEMBERSHIP_ACCOUNT_TYPE = {
    BASIC_FREE: 'BASIC_FREE',
    BASIC: 'BASIC',
    PLUS: 'PLUS',
    EMPLOYEE: 'EMPLOYEE',
};

export const MEMBERSHIP_RENEWAL_STATUS = {
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED',
};

export const DAYS_LEFT_SEGMENT_1 = 16;

export const MEMBERSHIP_DURATION_UNIT = {
    MONTHS: 'MONTHS',
    DAYS: 'DAYS',
};

export const MEMBERSHIP_MYTRIPS_REACTIVATION = 'membership_mytrips_reactivation';
